// This file is automatically compiled by esbuild, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import { Turbo, cable } from "@hotwired/turbo-rails"
import "./channels"

Rails.start()
ActiveStorage.start()

import "./controllers"

import "trix"
import "@rails/actiontext"
import "./disable_trix_attachments"
import "@hotwired/turbo-rails"
